var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranscriptOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12533 1.08594H3.25033C2.96301 1.08594 2.68746 1.20007 2.48429 1.40324C2.28113 1.6064 2.16699 1.88195 2.16699 2.16927V10.8359C2.16699 11.1233 2.28113 11.3988 2.48429 11.602C2.68746 11.8051 2.96301 11.9193 3.25033 11.9193H9.75033C10.0376 11.9193 10.3132 11.8051 10.5164 11.602C10.7195 11.3988 10.8337 11.1233 10.8337 10.8359V3.79427L8.12533 1.08594Z",
    stroke: "#5921F2",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 1.08594V3.2526C7.58301 3.53992 7.69714 3.81547 7.90031 4.01864C8.10347 4.2218 8.37902 4.33594 8.66634 4.33594H10.833",
    stroke: "#5921F2",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41634 4.875H4.33301",
    stroke: "#5921F2",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 7.03906H4.33301",
    stroke: "#5921F2",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 9.21094H4.33301",
    stroke: "#5921F2",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptOp);
export default __webpack_public_path__ + "static/media/TranscriptOP.0caa50add4b5ad3af3618078b636834b.svg";
export { ForwardRef as ReactComponent };